module.exports = __webpack_public_path__ + "static/gradientThree-5f460cadc04c018f2f76b9569063a0cf.svg";